<template>
  <div >
    <div class="wrap">
      <p class="wrap-top-title">{{form.training_title}}</p>
      <p class="wrap-top-item" >
        <span class="small-block">考试时长：{{form.exam_duration}}分钟</span>
        <span class="small-block">总分：{{form.total_scores}}分</span>
        <span class="small-block">合格分：{{form.pass_scores}}分</span>
        <span style="color:#BD3124;">{{name}}的得分：{{score}}分</span>
      </p>
      <p class="wrap-top-type" >题型：{{form.question_types}}</p>
    </div>
    <div class="wrap">
    <div  v-for="(item,index) in resultList">
      <p class="major">{{item.index}} 、{{typeMap[item.question_type]}}(共{{item.question_count}}题，每题{{item.question_scores}}分,共{{item.question_count * item.question_scores}}分)</p>
      <div style="margin-top: 20px" v-for="(ite,i) in item.questions">
        <div>
          <span class="title">{{i+1}}、{{ite.title}}</span>
        </div>
        <div>
          <div v-if="[2001,2002,2003].includes(item.question_type)" v-for="it in ite.options">
            <span class="answer">{{it.label}}:{{it.option_text}}</span>
          </div>

          <div v-if="[2005].includes(item.question_type)">
            <div>
              <span style="margin-bottom: 10px;" class="title">您的答案：</span>
              <el-input type="textarea" v-model="ite.user_answer"></el-input>
            </div>
            <div style="margin-top: 10px;">
              <span style="margin-bottom: 10px;"  class="title">正确答案：</span>
              <el-input type="textarea" v-model="ite.correct_answer"></el-input>
            </div>

          </div>
        </div>
        <div>
          <p v-if="[2001,2002,2003,2004].includes(item.question_type)" style="line-height: 40px;margin-top: 6px; border:1px solid #E99D42;padding:0 20px;border-radius: 3px">
            <span style="margin-right: 40px;">答案：{{ite.correct_answer ? ite.correct_answer.toString() : ''}}</span>
            <span style="margin-right: 40px;">您的答案：
                <span :style="{ color: ite.is_correct ? '#81B337' : '#BD3124' }">{{ite.user_answer ? ite.user_answer.toString() : ''}}</span>
                <span v-if="!ite.is_correct" style="color:#BD3124;">×</span>
                <span v-if="ite.is_correct" style="color:#81B337;">√</span>
              </span>
            <span>得分：{{ite.scores}}分</span>
          </p>
          <p v-else style="line-height: 40px; border:1px solid #E99D42;padding:0 20px;border-radius: 3px;margin-top: 6px">
            <span>得分：{{ite.scores}}分</span>
          </p>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import {checkSubmitAnswers, getExamDtl} from "@/api/training";

export default {
  name: "previewExam",
  data() {
    return {
      form:{},
      score: 0,
      name: '',
      questList: [],
      typeList: [],
      resultList: [],
      typeMap:{
        2001: '单选题',
        2002: '多选题',
        2003: '是非题',
        2004: '填空题',
        2005: '问答题'
      }
    }
  },
  mounted() {
    this.getData()
    this.getExamDetail()
  },
  methods: {
    getData(){ //获取题目
      checkSubmitAnswers({log_id: this.$route.query.log_id}).then(res => {
        this.resultList = res.data.questions
        this.score = res.data.user.score
        this.name = res.data.user.name
      })
    },
    getExamDetail(){
      getExamDtl({id: this.$route.query.exam_id}).then(res => {
        this.form = res.data
      })
    }
  }
}
</script>
<style scoped lang="scss">
.major{
  font-size: 32rpx;
  font-weight: bold;
  line-height: 40px;
  margin: 10px 0  10px 0;
}
.title,.answer{
  font-size: 28rpx;
  line-height: 32px;
}
.wrap{
  background: #fff;
  margin:10px;
  padding: 20px 40px;
  box-sizing: border-box;
  .wrap-top-title{
    color:#4095E5;
    font-weight: bold
  }
  .wrap-top-item{
    color:#9A9A9A;
    margin-top: 14px
  }
  .wrap-top-type{
    color:#9A9A9A;
    margin-top: 10px;
  }
}
.small-block{
  margin-right: 28px;
}
</style>